import { getArtistIndexData } from './getArtistIndexData'

export const getPageBuilderArtistIndexData = async (data: any) => {
  const newBody = await Promise.all(
    data.body.map(async (item: any) => {
      if (item._type === 'artworkData') {
        return await getArtistIndexData({ artworkData: item })
      }

      return item
    })
  )

  return newBody
}
